/**
 * Delivery Express Component
 * Toggles between in-stock (express) and out-of-stock (pre-order) states
 * based on the currently selected variant's availability.
 * Integrates with the theme's VariantSelects custom element.
 */

document.addEventListener('DOMContentLoaded', function () {
  initializeDeliveryExpress();
});

function initializeDeliveryExpress() {
  const deliveryExpressElement = document.querySelector('.delivery-express');
  if (!deliveryExpressElement) return;

  const variantSelects = document.querySelector('variant-selects:not([data-sticky])');
  if (!variantSelects) return;

  variantSelects.addEventListener('change', function () {
    setTimeout(function () {
      updateDeliveryExpressState(deliveryExpressElement, variantSelects);
    }, 50);
  });

  setTimeout(function () {
    updateDeliveryExpressState(deliveryExpressElement, variantSelects);
  }, 100);
}

/**
 * Switch the component between express (in-stock) and pre-order (out-of-stock).
 * @param {HTMLElement} element - The .delivery-express root element.
 * @param {HTMLElement} variantSelects - The variant-selects custom element.
 */
function updateDeliveryExpressState(element, variantSelects) {
  const currentVariant = variantSelects.currentVariant;
  if (!currentVariant) return;

  // variant.available already accounts for inventory_management + inventory_quantity
  const isPreorder = currentVariant.available !== true;

  const titleText = element.querySelector('.delivery-express__title-text');
  const badge = element.querySelector('.delivery-express__badge');
  const description = element.querySelector('.delivery-express__description');
  const inlineDescription = element.querySelector('.delivery-express__inline-description');

  if (isPreorder) {
    element.classList.add('delivery-express--preorder');
    if (titleText) {
      const url = element.dataset.preorderUrl || (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/pre-order');
      const label = element.dataset.preorderTitle || titleText.textContent;
      titleText.innerHTML = '';
      const link = document.createElement('a');
      link.className = 'delivery-express__link';
      link.href = url;
      link.textContent = label;
      titleText.appendChild(link);
    }
    if (inlineDescription) inlineDescription.textContent = element.dataset.preorderDescription || inlineDescription.textContent;
  } else {
    element.classList.remove('delivery-express--preorder');
    if (titleText) titleText.textContent = element.dataset.expressTitle || titleText.textContent;
    if (badge) badge.textContent = element.dataset.expressBadge || badge.textContent;
    if (description) description.textContent = element.dataset.expressDescription || description.textContent;
  }
}
